// ** React Imports
import { type ReactNode, useEffect } from 'react'

// ** Third Party Imports
import { Navigate, useLocation } from 'react-router-dom'

/**
 * Client-side permanent redirect that keeps `?query` and `#hash`
 * (e.g. /home#faqs -> /#faqs). A true HTTP 301 must also be configured
 * on the host, since the SPA can only redirect after it loads.
 */
export const RedirectTo = ({ to }: { to: string }) => {
	const { search, hash } = useLocation()

	return <Navigate to={{ pathname: to, search, hash }} replace />
}

/** Adds `<meta name="robots" content="noindex">` while the route is mounted */
export const NoIndex = ({ children }: { children: ReactNode }) => {
	useEffect(() => {
		const meta = document.createElement('meta')
		meta.name = 'robots'
		meta.content = 'noindex, nofollow'
		document.head.appendChild(meta)

		return () => {
			meta.remove()
		}
	}, [])

	return <>{children}</>
}
